import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { HIDDEN_ROLES } from '@repo/sdk/constants';
import { formatRoleName } from '@repo/sdk/helpers';
import { useQuery } from '@repo/tanstack/query';
import { Field, FieldError, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, selectVariant, Spinner } from '@repo/ui/components';
import { cn, VariantProps } from '@repo/ui/lib/utils';
import { ComponentProps } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
export const FormRoleSelect = t0 => {
  const $ = _c(70);
  const {
    "data-testid": dataTestId,
    isPending: t1,
    placeholder: t2,
    variant: t3
  } = t0;
  const isPending = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "" : t2;
  const variant = t3 === undefined ? "default" : t3;
  const field = useFieldContext();
  const api = useApi();
  let t4;
  if ($[0] !== api.roles.roles) {
    t4 = api.roles.roles.queryOptions({
      input: {
        perPage: 100
      }
    });
    $[0] = api.roles.roles;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    data,
    isLoading
  } = useQuery(t4);
  let T0;
  let T1;
  let T2;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== data?.data || $[3] !== dataTestId || $[4] !== field || $[5] !== isLoading || $[6] !== isPending || $[7] !== placeholder || $[8] !== variant) {
    const roles = (data?.data ?? []).filter(_temp);
    const value = field.state.value;
    const showSpinner = isPending || isLoading;
    T2 = Field;
    t16 = "gap-1";
    t17 = "Field";
    t18 = "FormRoleSelect";
    t19 = "form-role-select.tsx";
    t15 = "relative";
    T1 = Select;
    if ($[27] !== showSpinner || $[28] !== value) {
      t8 = showSpinner || HIDDEN_ROLES.includes(value);
      $[27] = showSpinner;
      $[28] = value;
      $[29] = t8;
    } else {
      t8 = $[29];
    }
    t9 = roles.map(_temp2);
    if ($[30] !== field) {
      t10 = val => val && field.handleChange(val);
      $[30] = field;
      $[31] = t10;
    } else {
      t10 = $[31];
    }
    t11 = value;
    t12 = "Select";
    t13 = "form-role-select.tsx";
    let t20;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = cn("flex w-full justify-between gap-2 p-0 text-base data-[size=default]:h-6");
      $[32] = t20;
    } else {
      t20 = $[32];
    }
    const t21 = dataTestId ?? "form-role-select-trigger";
    let t22;
    if ($[33] !== placeholder) {
      t22 = <SelectValue placeholder={placeholder} data-sentry-element="SelectValue" data-sentry-source-file="form-role-select.tsx" />;
      $[33] = placeholder;
      $[34] = t22;
    } else {
      t22 = $[34];
    }
    let t23;
    if ($[35] !== showSpinner) {
      t23 = showSpinner && <Spinner className="text-muted-foreground ml-auto size-4" />;
      $[35] = showSpinner;
      $[36] = t23;
    } else {
      t23 = $[36];
    }
    if ($[37] !== t21 || $[38] !== t22 || $[39] !== t23 || $[40] !== variant) {
      t14 = <SelectTrigger className={t20} data-testid={t21} variant={variant} data-sentry-element="SelectTrigger" data-sentry-source-file="form-role-select.tsx">{t22}{t23}</SelectTrigger>;
      $[37] = t21;
      $[38] = t22;
      $[39] = t23;
      $[40] = variant;
      $[41] = t14;
    } else {
      t14 = $[41];
    }
    T0 = SelectContent;
    t5 = "SelectContent";
    t6 = "form-role-select.tsx";
    t7 = roles.map(_temp3);
    $[2] = data?.data;
    $[3] = dataTestId;
    $[4] = field;
    $[5] = isLoading;
    $[6] = isPending;
    $[7] = placeholder;
    $[8] = variant;
    $[9] = T0;
    $[10] = T1;
    $[11] = T2;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
    $[20] = t18;
    $[21] = t19;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[9];
    T1 = $[10];
    T2 = $[11];
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
    t13 = $[15];
    t14 = $[16];
    t15 = $[17];
    t16 = $[18];
    t17 = $[19];
    t18 = $[20];
    t19 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t20;
  if ($[42] !== T0 || $[43] !== t5 || $[44] !== t6 || $[45] !== t7) {
    t20 = <T0 data-sentry-element={t5} data-sentry-source-file={t6}>{t7}</T0>;
    $[42] = T0;
    $[43] = t5;
    $[44] = t6;
    $[45] = t7;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== T1 || $[48] !== t10 || $[49] !== t11 || $[50] !== t12 || $[51] !== t13 || $[52] !== t14 || $[53] !== t20 || $[54] !== t8 || $[55] !== t9) {
    t21 = <T1 disabled={t8} items={t9} onValueChange={t10} value={t11} data-sentry-element={t12} data-sentry-source-file={t13}>{t14}{t20}</T1>;
    $[47] = T1;
    $[48] = t10;
    $[49] = t11;
    $[50] = t12;
    $[51] = t13;
    $[52] = t14;
    $[53] = t20;
    $[54] = t8;
    $[55] = t9;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  let t22;
  if ($[57] !== t15 || $[58] !== t21) {
    t22 = <div className={t15}>{t21}</div>;
    $[57] = t15;
    $[58] = t21;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== field.state.meta.errors) {
    t23 = <FieldError errors={field.state.meta.errors} data-sentry-element="FieldError" data-sentry-source-file="form-role-select.tsx" />;
    $[60] = field.state.meta.errors;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== T2 || $[63] !== t16 || $[64] !== t17 || $[65] !== t18 || $[66] !== t19 || $[67] !== t22 || $[68] !== t23) {
    t24 = <T2 className={t16} data-sentry-element={t17} data-sentry-component={t18} data-sentry-source-file={t19}>{t22}{t23}</T2>;
    $[62] = T2;
    $[63] = t16;
    $[64] = t17;
    $[65] = t18;
    $[66] = t19;
    $[67] = t22;
    $[68] = t23;
    $[69] = t24;
  } else {
    t24 = $[69];
  }
  return t24;
};
function _temp(role) {
  return !HIDDEN_ROLES.includes(role.name);
}
function _temp2(role_0) {
  return {
    label: formatRoleName(role_0.name),
    value: role_0.name
  };
}
function _temp3(role_1) {
  return <SelectItem data-testid={`form-role-select-option-${role_1.name}`} key={role_1.id} value={role_1.name}>{formatRoleName(role_1.name)}</SelectItem>;
}